import * as Models from "../../ts/rlAdmin.models";
import * as Consts from "../../ts/rlAdmin.consts";
import * as Utils from "../../ts/rlAdmin.utils";
import { NotifyService } from "../../services/notify-service";
import { EntityService } from "../../services/entity-service";
import { ContactService } from "../../services/contact-service";
import { EventService } from "assets/app/services/event-service";
import { EntityConfigService } from "../../services/entity-config-service"

export class EditEntityModalController {
    static $inject = ["$q", "$rootScope", "$uibModalInstance", "$window",
        "notifyService", "entityService", "contactService", "entityConfigService", "eventService",
        "charDataCollection", "existingRelationships", "idForRelationships",
        "relationshipCharTypeIDs", "parentCurrencyCharData", "parentEntityID", "showRequiredOnly", "singleSelect"];

    relationshipID: string;
    childEntityID: string;
    createMode: boolean = false;
    recordID: number;
    relationshipsRequired: _.Dictionary<boolean> = {};
    relationships: { [charTypeID: string]: Models.IEntityRelationship[] } = {};
    selectedRelationships: { [charTypeID: string]: Models.IEntity[] } = {};
    originalCharDataCollection: Models.ICharDataCollection;

    loading: boolean = false;
    charTypeID: number;

    constructor(
        private $q: ng.IQService,
        private $rootScope: ng.IRootScopeService,
        private $uibModal: ng.ui.bootstrap.IModalServiceInstance,
        private $window: ng.IWindowService,
        private notifyService: NotifyService,
        private entityService: EntityService,
        private contactService: ContactService,
        private entityConfigService: EntityConfigService,
        private eventService: EventService,
        private charDataCollection: Models.ICharDataCollection,
        private existingRelationships: Models.IEntityRelationship[],
        private idForRelationships: string,
        private relationshipCharTypeIDs: number[],
        private parentCurrencyCharData: Models.ICharDataValue,
        private parentEntityID: string,
        private showRequiredOnly: boolean,
        private singleSelect: boolean) {

        eventService.on(Consts.Events.EntityRelationshipsLoading, () => this.loading = true);
        eventService.on(Consts.Events.EntityRelationshipsLoaded, () => this.loading = false);

        if (existingRelationships) {
            if (existingRelationships.length == 0) this.loading = false;

            existingRelationships.forEach((er) => {
                this.relationships[er.childCharTypeID] = this.relationships[er.childCharTypeID] || [];
                this.relationships[er.childCharTypeID].push(er);
            });
        }

        const entityID = Utils.IdBuilder.splitEntityID(charDataCollection.entityID);
        const templateID = charDataCollection.templateMetaData.templateID;
        this.createMode = entityID.recID === -1;
        this.recordID = entityID.recID > 0 ? entityID.recID : undefined;
        this.charTypeID = entityID.charTypeID;

        if (charDataCollection) {
            this.originalCharDataCollection = _.cloneDeep(charDataCollection);
        }

        if (!_.isEmpty(relationshipCharTypeIDs)) {
            _.forEach(relationshipCharTypeIDs, (charTypeID) => {
                this.getRelationshipsRequired(entityID.charTypeID, templateID, charTypeID);
            });
        }
    }

    private getRelationshipsRequired(charTypeID: number, templateID: number, childCharTypeID: number) {
        this.entityConfigService.getRecordAssociationCharacteristicTemplateRequired(charTypeID, templateID, childCharTypeID)
            .then((res) => {
                if (res && res.charTypeID) {
                    this.relationshipsRequired[childCharTypeID.toString()] = true;
                }
            });
    }

    private saveRelationships(relationshipID: string) {
        const existingEntityIDs = _.map(this.existingRelationships, (rel) => { return Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID) });
        var selectedEntityIDs: string[] = this.getSelectedEntityIds();
        const addedEntityIDs = _.difference(selectedEntityIDs, existingEntityIDs);
        const removedEntityIDs = _.difference(existingEntityIDs, selectedEntityIDs);

        var addPromise;
        if (addedEntityIDs.length > 0) {
            if (addedEntityIDs.length > 20) {
                this.notifyService.notifyInfo("You've selected more than 20 associated entities. This may take a few minutes to create.");
            }

            addPromise = this.entityService.createEntityRelationships(
                relationshipID, addedEntityIDs)
                .catch(this.notifyService.errorResponseHandler)
                .finally(() => {
                });
        }

        var removePromise;
        if (removedEntityIDs.length > 0) {
            var removedRelationships = _.filter(this.existingRelationships, (rel) => {
                return removedEntityIDs.indexOf(Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID)) > -1;
            });

            removePromise = this.entityService.deleteEntityRelationships(_.map(removedRelationships, (entity) => {
                return Utils.IdBuilder.buildRelationshipID(entity);
            }))
                .catch(this.notifyService.errorResponseHandler)
                .finally(() => {
                });
        }

        this.notifyService.startProgress();
        return this.$q.all([addPromise, removePromise])
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    private getSelectedEntityIds() {
        let selectedEntityIDs: string[] = [];
        for (let charTypeID in this.selectedRelationships) {
            const relatedEntities = this.selectedRelationships[charTypeID];

            if (relatedEntities && relatedEntities.length > 0) {
                selectedEntityIDs = selectedEntityIDs.concat(_.map(relatedEntities, (entity) => {
                    return Utils.IdBuilder.buildEntityID(entity.divisionID, entity.charTypeID, entity.recordID)
                }));
            }
        }

        return selectedEntityIDs;
    }

    private UpdateEntity() {
        let promises: ng.IPromise<void>[] = [];
        const entityID = this.charDataCollection.entityID;
        const charDatas = this.charDataCollection.charDatas;
        var addedEntityIDs = [];
        var removedEntityIDs = [];

        var charTypeID = Utils.IdBuilder.splitEntityID(entityID).charTypeID;
        var warningMsg = "";

        var cmd = _.find(this.charDataCollection.templateMetaData.characteristicMetaDatas, (cd) => cd.systemIndicator == Consts.SystemIndicators.RoyaltyIncomeGroup);
        if (cmd) {
            var cds = this.charDataCollection.charDatas[cmd.tagLabel];
            this.$rootScope.$broadcast(Consts.Events.IncomeGroupsChanged, entityID, _.map(this.charDataCollection.charDatas[cmd.tagLabel], cd => cd.valueID));
        }

        if (charTypeID == Consts.CharTypeIDs.right || charTypeID == Consts.CharTypeIDs.usage) {
            const existingEntityIDs = _.map(this.existingRelationships, (rel) => { return Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID) });

            let selectedEntityIDs = this.getSelectedEntityIds();

            addedEntityIDs = _.difference(selectedEntityIDs, existingEntityIDs);
            removedEntityIDs = _.difference(existingEntityIDs, selectedEntityIDs);

            if (addedEntityIDs.length > 0 && charTypeID == Consts.CharTypeIDs.right) {
                warningMsg = "Are you sure you want to:\r\n";

                var addedCatalogItems = _.filter(addedEntityIDs, (id: string) => {
                    if (Utils.IdBuilder.splitEntityID(id).charTypeID == Consts.CharTypeIDs.property) { return id; }
                });

                var addedContactItems = _.filter(addedEntityIDs, (id: string) => {
                    if (Utils.IdBuilder.splitEntityID(id).charTypeID == Consts.CharTypeIDs.user) { return id; }
                });

                var addedMockItems = _.filter(addedEntityIDs, (id: string) => {
                    if (Utils.IdBuilder.splitEntityID(id).charTypeID == Consts.CharTypeIDs.mock) { return id; }
                });

                if (addedCatalogItems.length > 0) {
                    warningMsg += `Add ${addedCatalogItems.length} Catalog Items\n`;
                }

                if (addedContactItems.length > 0) {
                    warningMsg += `Add ${addedContactItems.length} Contact Items\n`;
                }

                if (addedMockItems.length > 0) {
                    warningMsg += `Add ${addedMockItems.length} Relative Items\n`;
                }
            }

            if (removedEntityIDs.length > 0) {

                if (_.isEmpty(warningMsg)) {
                    warningMsg = "Are you sure you want to:\r\n";
                }
                var removedCatalogItems = _.filter(removedEntityIDs, (id: string) => {
                    if (Utils.IdBuilder.splitEntityID(id).charTypeID == Consts.CharTypeIDs.property) { return id; }
                });

                var removedContactItems = _.filter(removedEntityIDs, (id: string) => {
                    if (Utils.IdBuilder.splitEntityID(id).charTypeID == Consts.CharTypeIDs.user) { return id; }
                });

                var removedMockItems = _.filter(removedEntityIDs, (id: string) => {
                    if (Utils.IdBuilder.splitEntityID(id).charTypeID == Consts.CharTypeIDs.mock) { return id; }
                });

                if (removedCatalogItems.length > 0) {
                    warningMsg += `Remove ${removedCatalogItems.length} Catalog Items\n`;
                    if (charTypeID == Consts.CharTypeIDs.usage) {
                        warningMsg += 'Selected Catalog Items and related Catalog Items will be removed from any Amounts on this Table\n'
                    }
                }

                if (removedContactItems.length > 0) {
                    warningMsg += `Remove ${removedContactItems.length} Contact Items`;
                }

                if (removedMockItems.length > 0) {
                    warningMsg += `Remove ${removedMockItems.length} Relative Items`;
                }
            }
        }

        if (_.isEmpty(warningMsg)) {
            this.SaveEntityAndRelationships();
        }
        else {
            if (addedEntityIDs.length > 0 || removedEntityIDs.length > 0) {
                if (this.$window.confirm(warningMsg)) {
                    this.SaveEntityAndRelationships();
                }
            }
            else {
                this.SaveEntityAndRelationships();
            }
        }
    }

    private AddRelationships(relationshipID: string) {
        var addedRelationshipsPromise = this.$q.defer();
        const existingEntityIDs = _.map(this.existingRelationships, (rel) => { return Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID) });

        var selectedEntityIDs: string[] = this.getSelectedEntityIds();

        const addedEntityIDs = _.difference(selectedEntityIDs, existingEntityIDs);

        if (addedEntityIDs.length > 0) {
            var addedRelationships = _.filter(this.existingRelationships, (rel) => {
                return addedEntityIDs.indexOf(Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID)) > -1;
            });

            if (addedEntityIDs.length > 20) {
                this.notifyService.notifyInfo("You've selected to add more than 20 associated entities. This may take a few minutes to edit.");
            }

            this.entityService.createEntityRelationships(relationshipID, addedEntityIDs)
                .then((res) => {
                    addedRelationshipsPromise.resolve(res.success);
                }, () => {
                    this.notifyService.notifyError("Error adding Relationships");
                    addedRelationshipsPromise.resolve(false);
                });
        }
        else {
            addedRelationshipsPromise.resolve(true);
        }
        return addedRelationshipsPromise.promise;
    }

    private RemoveRelationships(relationshipID: string) {
        var removedRelationshipsPromise = this.$q.defer();
        const existingEntityIDs = _.map(this.existingRelationships, (rel) => { return Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID) });

        var selectedEntityIDs: string[] = this.getSelectedEntityIds();

        const removedEntityIDs = _.difference(existingEntityIDs, selectedEntityIDs);

        if (removedEntityIDs.length > 0) {
            var removedRelationships = _.filter(this.existingRelationships, (rel) => {
                return removedEntityIDs.indexOf(Utils.IdBuilder.buildEntityID(rel.divisionID, rel.childCharTypeID, rel.childRecID)) > -1;
            });

            var removedRelationshipIDs = _.map(removedRelationships, (entity) => {
                return Utils.IdBuilder.buildRelationshipID(entity);
            })

            this.entityService.deleteEntityRelationships(removedRelationshipIDs)
                .then((res) => {
                    removedRelationshipsPromise.resolve(res.success);
                }, () => {
                    this.notifyService.notifyError("Error removing Relationships");
                    removedRelationshipsPromise.resolve(false);
                });
        }
        else {
            removedRelationshipsPromise.resolve(true);
        }
        return removedRelationshipsPromise.promise;
    }

    private SaveEntityAndRelationships() {
        const entityID = this.charDataCollection.entityID;
        const charDatas = this.charDataCollection.charDatas;
        let promises = [];
        this.notifyService.startProgress();
        if (this.idForRelationships) {
            let addedRelationshipsPromise = this.RemoveRelationships(this.idForRelationships).then(() => {
                return this.AddRelationships(this.idForRelationships);
            });
            promises.push(addedRelationshipsPromise);
        }

        promises.push(this.entityService.saveCharData(entityID, charDatas));

        this.$q.all(promises)
            .catch(this.notifyService.errorResponseHandler)
            .then(() => {
                this.notifyService.notifySuccess("Entity Saved");
                this.notifyService.endProgress();
                this.Saved(this.charDataCollection);
            });
    }

    private NewEntity() {
        this.notifyService.startProgress();

        let cdc = this.charDataCollection;
        let templateID = Utils.IdBuilder.buildTemplateID(0, cdc.templateMetaData.charTypeID, cdc.templateMetaData.templateID);
        if (cdc.templateMetaData.charTypeID !== Consts.CharTypeIDs.user) {
            this.entityService.createEntity(templateID, this.parentEntityID, cdc.charDatas)
                .then((res) => {
                    var newEntityID = Utils.IdBuilder.splitEntityID(res.entityID);
                    if (this.charDataCollection.templateMetaData.charTypeID == Consts.CharTypeIDs.usage) {
                        return this.entityService.getEntityParentRelationship(res.entityID)
                            .then((rels) => {
                                var rel = _.find(rels, (rel) => {
                                    return rel.childRecID == newEntityID.recID;
                                });

                                if (rel) {
                                    return this.saveRelationships(Utils.IdBuilder.buildRelationshipID(rel))
                                        .then((relRes) => {
                                            this.$uibModal.close({ entityID: res.entityID, relRecID: res.relRecID });
                                        });
                                } else {
                                    this.$uibModal.close({ entityID: res.entityID, relRecID: res.relRecID });
                                }
                            });
                    } else {
                        return this.entityService.getEntityParentRelationship(res.entityID)
                            .then((rels) => {
                                var rel = _.find(rels, (rel) => {
                                    return rel.childRecID == newEntityID.recID;
                                });
                                return this.saveRelationships(Utils.IdBuilder.buildRelationshipID(rel))
                                    .then((relRes) => {
                                        if (this.charDataCollection.templateMetaData.charTypeID == Consts.CharTypeIDs.amount) {
                                            this.eventService.call(Consts.Events.RefreshTables);
                                        }
                                        this.$uibModal.close({ entityID: res.entityID, relRecID: res.relRecID });
                                    });
                            });
                    }
                })
                .catch(this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
        else {
            this.contactService.createContact(templateID, cdc.charDatas, undefined, undefined, undefined, undefined, undefined)
                .then((result) => {
                    this.$uibModal.close({ entityID: result.entityID });
                    return result;
                })
                .catch(this.notifyService.errorResponseHandler)
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    Save(isValid: boolean) {
        if (isValid) {
            var split = Utils.IdBuilder.splitEntityID(this.charDataCollection.entityID);
            var isCreate: boolean = true;

            if (split.recID > 0) {
                isCreate = false;
            }

            if (this.charTypeID == Consts.CharTypeIDs.amount) {
                this.AllowAmountToSave(isCreate)
                    .then((allowed) => {
                        if (allowed) {
                            if (isCreate) {
                                this.NewEntity();
                            }
                            else {
                                this.UpdateEntity();
                            }
                        }
                        else {
                            alert("Amount record with mixed currencies not allowed on an Accounting record.");
                        }
                    });
            }
            else {
                if (isCreate) {
                    this.NewEntity();
                }
                else {
                    this.UpdateEntity();
                }
            }
        }
    }

    public Saved(cdc: Models.ICharDataCollection) {
        this.$uibModal.close(cdc);
    }

    public Cancel() {
        this.$uibModal.dismiss();
    }

    private AllowAmountToSave(isCreate: boolean) {
        var parentEntityIDSplit = Utils.IdBuilder.splitEntityID(this.parentEntityID);
        var allowSavePromise = this.$q.defer();
        var promises = [];
        var invoiceEntityCharData: Models.IEntityCharDataPair = undefined;
        var relatedAmountsCount: number = 0;

        if (parentEntityIDSplit.charTypeID == Consts.CharTypeIDs.invoice) {

            promises.push(this.entityService.getEntity(this.parentEntityID)
                .then((result) => {
                    invoiceEntityCharData = result;
                }));

            promises.push(this.entityConfigService.getRecordAssociationParentChildTemplateList(parentEntityIDSplit.charTypeID, parentEntityIDSplit.recID)
                .then((result) => {
                    var relatedAmounts = _.find(result, r => r.charTypeID == Consts.CharTypeIDs.amount);
                    if (relatedAmounts != undefined) {
                        relatedAmountsCount = relatedAmounts.recordCount;
                    }
                }));

            this.$q.all(promises)
                .then(() => {
                    if (relatedAmountsCount == 0) {
                        allowSavePromise.resolve(true);
                        return;
                    }
                    else {

                        if (this.amountHasInvoiceWithSameCurrency(invoiceEntityCharData, relatedAmountsCount, isCreate)) {
                            allowSavePromise.resolve(true);
                        }
                        else {
                            allowSavePromise.resolve(false);
                        }
                    }
                });
        }
        else if (parentEntityIDSplit.charTypeID == Consts.CharTypeIDs.relationship && !isCreate) {
            this.entityService.getRelatedParentEntities(this.charDataCollection.entityID, Consts.CharTypeIDs.invoice)
                .then((result) => {
                    if (result.length > 0) {
                        invoiceEntityCharData = {
                            record: result[0].record,
                            charDataCollection: result[0].charDataCollection
                        };
                    }
                })
                .finally(() => {
                    if (invoiceEntityCharData != undefined) {
                        parentEntityIDSplit = Utils.IdBuilder.splitEntityID(invoiceEntityCharData.record.id);
                        this.entityConfigService.getRecordAssociationParentChildTemplateList(parentEntityIDSplit.charTypeID, parentEntityIDSplit.recID)
                            .then((result) => {
                                var relatedAmounts = _.find(result, r => r.charTypeID == Consts.CharTypeIDs.amount);
                                if (relatedAmounts != undefined) {
                                    relatedAmountsCount = relatedAmounts.recordCount;

                                    if (this.amountHasInvoiceWithSameCurrency(invoiceEntityCharData, relatedAmountsCount, isCreate)) {
                                        allowSavePromise.resolve(true);
                                    }
                                    else {
                                        allowSavePromise.resolve(false);
                                    }
                                }
                            });
                    }
                    else {
                        allowSavePromise.resolve(true);
                    }
                });
        }
        else {
            allowSavePromise.resolve(true);
        }

        return allowSavePromise.promise;
    }

    private amountHasInvoiceWithSameCurrency(invoiceEntityCharData: Models.IEntityCharDataPair, relatedAmountsCount: number, isCreate: boolean): boolean {
        var amountHasInvoiceWithSameCurrencyID: boolean;

        var amountCurrencyValueId = Utils.CharUtil.GetCurrencyLovValueId(this.charDataCollection);
        var invoiceCurrencyValueId = Utils.CharUtil.GetCurrencyLovValueId(invoiceEntityCharData.charDataCollection);

        if (invoiceCurrencyValueId == undefined) {
            amountHasInvoiceWithSameCurrencyID = true;
            return amountHasInvoiceWithSameCurrencyID;
        }
        else {
            if (relatedAmountsCount >= 2 && invoiceCurrencyValueId != amountCurrencyValueId) {
                amountHasInvoiceWithSameCurrencyID = false;
            } else if (relatedAmountsCount == 1 && !isCreate) {
                amountHasInvoiceWithSameCurrencyID = true;
            }
            else if (relatedAmountsCount == 1 && isCreate && invoiceCurrencyValueId != amountCurrencyValueId) {
                amountHasInvoiceWithSameCurrencyID = false;
            }
            else {
                amountHasInvoiceWithSameCurrencyID = true;
            }
        }

        return amountHasInvoiceWithSameCurrencyID;
    }
}